define(['../services/site'], function () {
    'use strict';

    return {
        name: 'sitesCtrl',
        arguments: [
            '$rootScope',
            '$scope',
            'Site',
            function ($rootScope, $scope, Site) {
                $scope.sites = Site.getAllSites();

                $scope.openAddSite = function () {
                    $rootScope.$broadcast('openAddSite');
                };
            },
        ],
    };
});
